export const USER_NAME_MAX_LENGTH = 16;
export const USER_NAME_MIN_LENGTH = 2;
